import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  root: {
    height: 100,
    minHeight: 100,
    maxHeight: 100,
  },
}))

/** Give space between the end of content for the HelpScout button. */
const BottomBeaconSpacer: React.FC<
  React.PropsWithChildren<StyleClassesProp<typeof useStyles>>
> = (props) => {
  const { classes } = useStyles(undefined, {
    props,
  })

  return <div className={classes.root} />
}

export default BottomBeaconSpacer
